module.exports = __webpack_public_path__ + "media/assets/imaginelearning-0ce97c5deda84718bdff77dcd0ccff28.png";